<template>
    <header class="common-header-finuslugi"
        v-bind:class="{
            _transparent: !isScrolled && isTransparent,
            _with_shadow: isShadowNeeded,
            _gray: isGray,
        }"
        >
        <div class="common-header-finuslugi__container">
            <svg width="234" height="35" viewBox="0 0 234 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_12624_10533)">
                    <path d="M228.035 14.4457C231.122 14.4457 233.009 16.5282 233.009 19.8112C233.009 20.2032 232.96 20.6442 232.911 21.0852H225.071C225.414 22.8492 226.786 23.7802 228.55 23.7802C229.799 23.7802 230.681 23.4127 231.441 22.7512L232.568 24.4662C231.318 25.4707 229.995 25.9852 228.305 25.9852C224.801 25.9852 222.4 23.6087 222.4 20.1787C222.4 16.9692 224.728 14.4457 228.035 14.4457ZM227.986 16.6262C226.541 16.6262 225.389 17.5817 225.095 19.2722H230.485C230.412 17.5327 229.383 16.6262 227.986 16.6262Z" fill="#6737AF"/>
                    <path d="M218.253 25.9117C216.293 25.9117 214.994 24.7847 214.994 22.3347V17.0182L213.059 16.8712V14.7397H214.994L215.068 11.2362H217.665V14.7397H221.046V17.0182H217.665V22.0652C217.665 23.1432 218.155 23.4617 218.865 23.4617C219.502 23.4617 220.09 23.2902 220.703 22.8982L221.56 24.9072C220.556 25.5442 219.502 25.9117 218.253 25.9117Z" fill="#6737AF"/>
                    <path d="M206.823 14.5437C209.616 14.5437 211.331 15.9647 211.331 18.6107V25.6667H209.543L209.053 24.0252C208.244 25.1767 206.946 25.8872 205.157 25.8872C203.148 25.8872 201.727 24.7602 201.727 22.8247C201.727 20.3257 203.932 18.9537 207.264 18.9537C207.828 18.9537 208.244 18.9782 208.636 19.0027V18.5127C208.636 17.3857 207.803 16.8222 206.407 16.8222C205.329 16.8222 204.128 17.1652 203.001 17.7042L202.242 15.6707C203.859 14.9357 205.353 14.5437 206.823 14.5437ZM205.941 23.8782C207.509 23.8782 208.661 22.7267 208.71 20.7422C208.269 20.6932 207.926 20.6687 207.436 20.6687C205.5 20.6687 204.373 21.3547 204.373 22.5552C204.373 23.4127 204.961 23.8782 205.941 23.8782Z" fill="#6737AF"/>
                    <path d="M197.389 25.9117C195.429 25.9117 194.131 24.7847 194.131 22.3347V17.0182L192.195 16.8712V14.7397H194.131L194.204 11.2362H196.801V14.7397H200.182V17.0182H196.801V22.0652C196.801 23.1432 197.291 23.4617 198.002 23.4617C198.639 23.4617 199.227 23.2902 199.839 22.8982L200.697 24.9072C199.692 25.5442 198.639 25.9117 197.389 25.9117Z" fill="#6737AF"/>
                    <path d="M187.062 25.9117C185.445 25.9117 184.098 25.5197 182.824 24.7112L183.877 22.8247C184.808 23.4127 185.837 23.7312 186.866 23.7312C187.846 23.7312 188.483 23.2902 188.483 22.6042C188.483 21.7957 187.454 21.4037 186.376 20.9872C184.637 20.3257 183.289 19.4192 183.289 17.6307C183.289 15.6217 185.078 14.5682 187.16 14.5682C188.41 14.5682 189.561 14.8622 190.737 15.5482L189.806 17.3367C188.998 16.9202 188.116 16.6997 187.381 16.6997C186.548 16.6997 185.837 16.9447 185.837 17.6307C185.837 18.3412 186.646 18.7577 187.822 19.1742C189.733 19.8847 191.105 20.7912 191.105 22.6042C191.105 24.6377 189.463 25.9117 187.062 25.9117Z" fill="#6737AF"/>
                    <path d="M173.543 23.1187H181.358V25.6667H170.652V9.00667H181.138V11.5547H173.543V15.9647H180.182V18.4392H173.543V23.1187Z" fill="#6737AF"/>
                    <path d="M162.774 14.4457C165.861 14.4457 167.747 16.5282 167.747 19.8112C167.747 20.2032 167.698 20.6442 167.649 21.0852H159.809C160.152 22.8492 161.524 23.7802 163.288 23.7802C164.538 23.7802 165.42 23.4127 166.179 22.7512L167.306 24.4662C166.057 25.4707 164.734 25.9852 163.043 25.9852C159.54 25.9852 157.139 23.6087 157.139 20.1787C157.139 16.9692 159.466 14.4457 162.774 14.4457ZM162.725 16.6262C161.279 16.6262 160.128 17.5817 159.834 19.2722H165.224C165.15 17.5327 164.121 16.6262 162.725 16.6262Z" fill="#27242D"/>
                    <path d="M151.986 25.6667V8.02666H154.657L154.681 25.6667H151.986Z" fill="#27242D"/>
                    <path d="M144.262 14.4702C147.276 14.4702 149.481 16.8712 149.481 20.1542C149.481 23.5597 147.3 25.9362 144.262 25.9362C142.743 25.9362 141.469 25.3482 140.587 24.4172C140.636 25.1767 140.636 26.0587 140.636 27.0142V31.0567H137.966V14.7397H139.779L140.293 16.4057C141.2 15.2052 142.572 14.4702 144.262 14.4702ZM143.699 23.6087C145.536 23.6087 146.761 22.2122 146.761 20.2277C146.761 18.1942 145.536 16.8222 143.699 16.8222C141.812 16.8222 140.538 18.1697 140.538 20.1787C140.538 22.2367 141.837 23.6087 143.699 23.6087Z" fill="#27242D"/>
                    <path d="M131.229 14.4457C133.63 14.4457 134.977 16.0627 134.977 18.6352V25.6667H132.307V18.9292C132.307 17.6062 131.621 16.8467 130.543 16.8467C128.852 16.8467 128.093 18.3412 128.093 19.8112V25.6667H125.447V18.9047C125.447 17.7777 124.859 16.8467 123.658 16.8467C121.992 16.8467 121.233 18.3412 121.233 19.8112V25.6667H118.562V14.7397H120.375L120.914 16.4792C121.649 15.1807 122.85 14.4457 124.393 14.4457C125.961 14.4457 127.113 15.1807 127.676 16.3812C128.387 15.2052 129.587 14.4457 131.229 14.4457Z" fill="#27242D"/>
                    <path d="M114.096 12.4612C113.067 12.4612 112.43 11.7507 112.43 10.8687C112.43 9.98667 113.067 9.27617 114.096 9.27617C115.125 9.27617 115.762 9.98667 115.762 10.8932C115.762 11.7752 115.101 12.4612 114.096 12.4612ZM112.749 25.6667V14.7397H115.419V25.6667H112.749Z" fill="#27242D"/>
                    <path d="M104.314 25.9852C102.035 25.9852 99.8549 25.2502 98.2134 23.9517L99.5609 21.6977C100.81 22.7757 102.476 23.4127 104.216 23.4127C105.882 23.4127 107.327 22.6532 107.327 21.1832C107.327 19.6152 105.612 18.9537 103.726 18.3412C100.933 17.4347 98.7524 15.9157 98.7524 13.2697C98.7524 10.3297 101.3 8.68817 104.314 8.68817C106.249 8.68817 107.891 9.15367 109.728 10.3787L108.479 12.5347C107.058 11.6282 105.833 11.2362 104.461 11.2362C102.991 11.2362 101.692 11.8732 101.692 13.1227C101.692 14.6417 103.383 15.2787 105.098 15.8667C107.989 16.7977 110.243 18.1942 110.243 21.0362C110.243 24.1477 107.621 25.9852 104.314 25.9852Z" fill="#27242D"/>
                </g>
                <g clip-path="url(#clip1_12624_10533)">
                    <path d="M65.6483 0H22.6124V15.3129H0V35H65.6483V0Z" fill="#FF0508"/>
                    <path d="M5.07095 28.6307H6.21317C6.58725 28.6307 6.88993 28.4671 7.00987 28.1636L3.64746 20.1193H5.84623L8.11496 26.3371H8.48833L10.7299 20.12H12.8794L9.82044 27.5329C9.12226 29.2229 8.11496 30.3693 6.14892 30.3693H5.07167V28.6307H5.07095ZM44.1634 30.3636V20.1136H50.6605V21.9671H46.1994V30.3636H44.1634ZM22.901 30.3636V28.3914H23.5342C24.423 28.3914 24.7471 27.8964 24.7742 26.445L24.8934 20.1571V20.1086H32.0459V30.3586H30.0263V21.9671H26.8002L26.7081 26.3043C26.6382 29.1407 25.7494 30.3636 23.7626 30.3636H22.901ZM52.3881 15.2114V4.96142H54.4191V9.11357H58.5068V4.96142H60.5378V15.2114H58.5068V10.9671H54.4191V15.2114H52.3881ZM20.1882 26.8693L22.2192 27.1514C21.7052 29.3314 19.9998 30.6243 17.7803 30.6243C14.4835 30.6243 12.9451 28.2107 12.9451 25.2057C12.9451 22.2007 14.5806 19.8579 17.8774 19.8579C19.8862 19.8579 21.4297 20.8414 22.1278 22.7429L20.1896 23.6129C19.7456 22.5586 18.9982 21.7379 17.7803 21.7379C15.7493 21.7379 15.0454 23.4007 15.0454 25.21C15.0454 27.0193 15.7928 28.7536 17.8717 28.7536C19.1167 28.7429 19.8848 28.0143 20.1882 26.8679V26.8693ZM51.994 30.3636V20.1136H54.0243V28.5107H54.3977L56.7099 20.1136H60.5428V30.3636H58.5118V21.9671H58.1384L55.8697 30.3636H51.9933H51.994ZM41.7597 15.2114V4.96142H43.79V13.3579H44.1641L46.4764 4.96142H50.2828V15.2114H48.2518V6.79285H47.8785L45.6369 15.2114H41.7597ZM34.9107 28.6307H36.0529C36.4263 28.6307 36.7297 28.4671 36.8489 28.1636L33.4865 20.1193H35.6853L37.954 26.3371H38.3281L40.5697 20.12H42.7192L39.6602 27.5321C38.9613 29.2221 37.9547 30.3686 35.9887 30.3686H34.9114V28.6307H34.9107ZM34.7701 13.1736L35.2355 13.1514C36.9895 13.0593 38.1325 11.7929 38.1325 10.0814C38.1325 8.37 36.9895 7.17357 35.2355 7.08071L34.7701 7.05857V13.1729V13.1736ZM32.8097 15.8471V15.0057L32.3443 14.9836C29.3552 14.8421 27.5084 13.1086 27.5084 10.0814C27.5084 6.86928 29.4045 5.39142 32.3443 5.25L32.8097 5.22785V4.37428H34.7751V5.21642L35.2412 5.23857C38.2567 5.37999 40.1028 6.80928 40.1028 10.07C40.1028 13.0979 38.2574 14.8314 35.2412 14.9721L34.7751 14.9943V15.8364H32.8097V15.8471ZM32.8097 7.04857L32.3443 7.07071C30.5681 7.16357 29.4687 8.26642 29.4687 10.0707C29.4687 11.875 30.546 13.0493 32.3443 13.1414L32.8097 13.1636V7.04928V7.04857Z" fill="white"/>
                </g>
                <path d="M85.9551 23.9774L75.2637 13.286L76.8822 11.6674L87.5885 22.344L85.9551 23.9774Z" fill="#27242D"/>
                <path d="M76.8969 23.9774L87.5884 13.286L85.9698 11.6674L75.2635 22.344L76.8969 23.9774Z" fill="#27242D"/>
                <defs>
                    <clipPath id="clip0_12624_10533">
                        <rect width="136.84" height="30.625" fill="white" transform="translate(97.1597 2.1875)"/>
                    </clipPath>
                    <clipPath id="clip1_12624_10533">
                        <rect width="65.6483" height="35" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
            <div class="common-header-finuslugi__menu"></div>
            <a class="common-header-finuslugi__phone"
               v-bind:href="'tel:' + contacts.phone.value"
            >
                <span class="common-header-finuslugi__phone-icon">
                    <icon name="phone"/>
                </span>
                <span class="common-header-finuslugi__phone-number"
                      v-text="contacts.phone.valueFormatted"
                />
            </a>
        </div>
    </header>
</template>

<script>
import config from '~/config';

export default {
    name: 'common-header-finuslugi',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        isTransparent: {
            type: Boolean,
            default: false,
        },
        isShadowNeeded: {
            type: Boolean,
            default: false,
        },
        isGray: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        modal: {
            isOpen: false,
        },
        isScrolled: false,
    }),
    computed: {
        contacts() {
            return this.$store.getters['site/contacts'];
        },
        isAuthPage() {
            return window.location.href.indexOf(config.urls.auth.login) > -1;
        },
        isAuthorized() {
            return this.$store.getters['users/isAuthorized'];
        },
        user() {
            return this.$store.getters['users/user'];
        },
    },
    methods: {
        checkScroll() {
            if (window.scrollY > 0) {
                this.isScrolled = true;
            } else {
                this.isScrolled = false;
            }
        },
    },
    mounted() {
        if (this.isTransparent) {
            window.addEventListener('scroll', this.checkScroll);
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.checkScroll);
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.common-header-finuslugi {
    display: flex;
    align-items: center;
    width: 100%;
    height: 77px;

    background-color: @color-gray-lightest;

    transition: background-color @duration-fast @easing-default;
    &._with_shadow {
        box-shadow: 0 0 3px 0 fade(@color-primary, 10%);
    }
    &._gray {
        background-color: @color-gray-lighter;
    }
    &._transparent {
        color: @color-gray-lightest;

        background-color: transparent;
    }
    &__container {
        .container();

        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    &__menu {
        .typography-body();

        flex: 1 1 auto;
        width: 100%;

        &-item {
            margin-right: 21px;

            text-decoration: none;
            white-space: nowrap;
        }
    }
    &__phone {
        flex: 0 0 auto;
        justify-self: flex-end;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 36px;

        text-align: right;
        text-decoration: none;
        &-icon {
            display: inline-block;
            padding: 4px;

            font-size: 1.6rem;
        }
        &-number {
            .typography-body();
        }
    }
    &__modal {
        display: none;
    }
    @media @media-lg-down {
        &__burger {
            position: relative;
            z-index: 1;

            display: block;

            font-size: 2.2rem;

            cursor: pointer;
            &:before {
                content: '';

                position: absolute;
                top: -12px;
                right: -12px;
                bottom: -12px;
                left: -12px;
                z-index: 1;

                display: block;
            }
        }
        &__logo {
            padding: 20px 0 18px 13px;
            margin: 0 auto;

            font-size: 1.8rem;
        }
        &__menu,
        &__phone {
            display: none;
        }
        &__modal {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: @z-index-header-menu;

            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: flex-start;
            padding: 8px 40px 40px;

            color: @color-gray-lightest;

            background-color: @color-primary;
            background-image: @color-gradient-background;
            opacity: 0;
            pointer-events: none;

            transition: opacity @duration-fast ease-in-out;

            .cms-toolbar-expanded & {
                padding-top: @container-cms-height;
            }
            &._active {
                opacity: 1;
                pointer-events: all;
            }
            &-header {
                flex: 0 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 60px;
                &-close {
                    position: relative;
                    z-index: 1;

                    flex: 0 0 auto;
                    display: block;

                    font-size: 2.2rem;

                    cursor: pointer;

                    &:before {
                        content: '';

                        position: absolute;
                        top: -12px;
                        right: -12px;
                        bottom: -12px;
                        left: -12px;
                        z-index: 1;

                        display: block;
                    }
                }
                &-info {
                    flex: 1 1 auto;
                    display: block;
                    padding-right: 8px;

                    text-align: right;
                    &-name {
                        .typography-heading();

                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    &-email {
                        .typography-caption();

                        margin-top: -1px;

                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
                &-home {
                    flex: 0 0 auto;
                }
            }
            &-menu {
                flex: 1 1 auto;
                padding: 31px 0;
                overflow: auto;
                &-item {
                    display: block;
                    &-text {
                        .typography-medium();

                        display: inline-block;
                        padding: 11px 0;

                        text-decoration: none;
                    }
                }
            }
            &-contact {
                flex: 0 0 auto;
                & + & {
                    margin-top: 24px;
                }
                &-title {
                    .typography-body();
                }
                &-content {
                    &-text {
                        .typography-large();

                        display: inline-block;

                        text-decoration: none;
                    }
                }
            }
        }
    }
    @media @media-md-down {
        height: 60px;
        &__modal {
            padding: 0 24px 40px;
        }
    }
}
</style>
